"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tiers = exports.SESSION_ORG_TIER = void 0;
exports.getOrgTierWeb = getOrgTierWeb;
exports.checkTierWeb = checkTierWeb;
exports.checkTier = checkTier;
exports.SESSION_ORG_TIER = 'org_tier';
exports.Tiers = {
    free: {
        id: 'free',
        name: 'Free',
        price: 0,
        features: [],
    },
    pro: {
        id: 'pro',
        name: 'Pro',
        price: 400,
        features: ['CopyItinerary', 'PDF'],
    },
    enterpriseFree: {
        id: 'enterpriseFree',
        name: 'Starter',
        price: 0,
        features: ['CopyItinerary', 'PDF', 'CVSImport'],
    },
    enterprise: {
        id: 'enterprise',
        name: 'Enterprise',
        price: 0,
        features: [
            'CopyItinerary',
            'PDF',
            'Costing',
            'CVSImport',
            'Permissions',
            'Theming',
            'GuestMode',
            'Settings',
            'modifyClaims',
            'todoList',
            'Stands',
        ],
    },
};
function getOrgTierWeb() {
    const tier = localStorage.getItem(exports.SESSION_ORG_TIER);
    if (!tier) {
        return 'free';
    }
    return tier;
}
function checkTierWeb(feature) {
    const tier = getOrgTierWeb();
    return checkTier(tier, feature);
}
function checkTier(tier, feature) {
    if (!tier) {
        return false;
    }
    return exports.Tiers[tier]?.features?.includes(feature) ?? false;
}
